import { createContext, Dispatch, SetStateAction, useContext, useEffect, useState } from "react"
import { getCookie, SIDEBAR_COOKIE, setCookie } from "../utils/cookies"


interface SideabarContext {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

const defaultContext: SideabarContext = {
  isOpen: true,
  setIsOpen: () => {
  }
}
const SidebarContext = createContext(defaultContext)

interface SidebarContextProviderProps {
  children: any
}

export const SidebarContextProvider = (props: SidebarContextProviderProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(true)

  useEffect(() => {
    setCookie(SIDEBAR_COOKIE, isOpen.toString())
  }, [isOpen])

  useEffect(() => {
    const initialIsOpen = getCookie(SIDEBAR_COOKIE)
    if (initialIsOpen) {
      setIsOpen(JSON.parse(initialIsOpen))
    }
  }, [])

  return (
    <SidebarContext.Provider value={{ isOpen, setIsOpen }}>
      {props.children}
    </SidebarContext.Provider>
  )
}

export const useSidebarState = () => {
  return useContext(SidebarContext)
}
